import { render, staticRenderFns } from "./painel.vue?vue&type=template&id=50e76543&scoped=true&"
import script from "./painel.vue?vue&type=script&lang=js&"
export * from "./painel.vue?vue&type=script&lang=js&"
import style0 from "./painel.vue?vue&type=style&index=0&id=50e76543&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e76543",
  null
  
)

export default component.exports